import * as React from "react";
export const SendIcon = (props: React.SVGProps<SVGSVGElement>) => {
  props = {
    ...props,
    color: props.color,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={11.2}
      viewBox="0 0 13 11.2"
      {...props}
    >
      <path
        d="M-741.1-528.708a.8.8,0,0,1-.16-.887l1.992-4.472-1.992-4.472a.8.8,0,0,1,.16-.887.8.8,0,0,1,.884-.178l11.395,4.8.013.005,0,0,.01,0,.007,0,.008,0,.013.007h0l.016.009h0a.8.8,0,0,1,.235.194h0l.01.012,0,0,.007.009.011.015h0l.008.011h0a.8.8,0,0,1,.137.365h0v.046s0,0,0,.007,0,.008,0,.012,0,0,0,.006,0,.012,0,.018,0,.012,0,.018,0,0,0,.006,0,.008,0,.012,0,0,0,.007v.045h0a.8.8,0,0,1-.137.365h0l-.02.028-.007.009,0,0a.8.8,0,0,1-.246.208h0l-.017.009,0,0-.012.006-.008,0-.007,0-.01,0,0,0-.013.005-11.395,4.8a.8.8,0,0,1-.311.063A.8.8,0,0,1-741.1-528.708Zm2.129-2.085,5.873-2.473h-4.772Zm5.873-4.075-5.873-2.473,1.1,2.473Z"
        transform="translate(741.334 539.667)"
        fill="currentColor"
      />
    </svg>
  );
};
